import clsx from 'clsx'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Empty from '@/components/Empty/Empty'
import Loading from '@/components/Loading'

import type { SectionFormValues } from '../../hooks/useSectionForm'
import { useCurriculumBasketCourse } from '../../queries/useCurriculumBasketCourse'
import CourseCollapsible from '../CourseCollapsible'
import CurriculumCourseBasketBlock from '../CurriculumCourseBasketBlock'
import styles from './SectionFormCourse.module.scss'
import SectionFormLessonBlocks from './SectionFormLessonBlocks'

const SectionFormCourse = () => {
  const form = useFormContext<SectionFormValues>()

  const course = form.watch('course')
  const curriculum = form.watch('curriculum')

  const { data, isLoading } = useCurriculumBasketCourse({
    courseId: course?.value,
    curriculumId: curriculum?.value
  })

  return (
    <Loading
      className={clsx(styles.container, !data && styles.containerEmpty)}
      innerClassName={styles.innerContainer}
      spinning={isLoading}
    >
      {!data && !isLoading ? <CourseEmpty /> : null}
      {data ? (
        <>
          <CourseCollapsible
            title={data.course.name}
            timeUnit={data.timeUnit}
            defaultOpen
          >
            <CurriculumCourseBasketBlock semesters={data.semesters} />
          </CourseCollapsible>
          {data.timeUnit === 'week' ? (
            <SectionFormLessonBlocks semesters={data.semesters} />
          ) : null}
        </>
      ) : null}
    </Loading>
  )
}

const CourseEmpty = () => {
  const { t } = useTranslation('sections')

  return (
    <Empty
      title={t('header.no-course-yet')}
      description={t('help.fill-curriculum-and-course')}
    />
  )
}

export default SectionFormCourse
